import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { SystemVariablesTableDefinitionZod } from '../tables';

type Arguments = unknown;

export const schemaSystemVariableResolver_GetAll = z.array(SystemVariablesTableDefinitionZod);

export type SchemaSystemVariableResolver_GetAll = z.infer<typeof schemaSystemVariableResolver_GetAll>;

export type SystemVariableResolver_GetAll = Resolver<Arguments, SchemaSystemVariableResolver_GetAll>;
